export const formatDate = (dateField) => {
  if (!dateField) return "N/A";
  if (dateField && dateField._seconds) {
    return new Date(dateField._seconds * 1000).toLocaleString();
  }
  if (dateField instanceof Date) {
    return dateField.toLocaleString();
  }
  if (typeof dateField === "string") {
    return new Date(dateField).toLocaleString();
  }
  return "Invalid Date";
};

export const formatAudioTime = (time) => {
  const padZero = (num) => num.toString().padStart(2, "0");

  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  return `${padZero(minutes)}:${padZero(seconds)}`;
};
